export default "__VITE_ASSET__1rE27cEp__"